import { AddListenerOverloads } from '@reduxjs/toolkit/dist/listenerMiddleware/types'
import { User } from '@pff-consumer/schema/user'
import { saveTokenToStorage, saveUserToStorage } from '@pff-consumer/utils'
import { accountApi } from '../../lib/account/account-api'
import { accountSlice } from '../../lib/account/account.slice'
import { checkHasCurrentSubscription } from '../../lib/account/util/checkHasCurrentSubscription'
import { checkHasExpiredSubscription } from '../../lib/account/util/checkHasExpiredSubscription'

const updateStorage = async (user: User, token: string) => {
  const isPremiumUser = checkHasCurrentSubscription(user)
  const isSubscriptionExpired = !isPremiumUser && checkHasExpiredSubscription(user)
  await saveTokenToStorage(user, token, isPremiumUser, isSubscriptionExpired)
}

const updateUserInStorage = async (user: User) => {
  const isPremiumUser = checkHasCurrentSubscription(user)
  const isSubscriptionExpired = !isPremiumUser && checkHasExpiredSubscription(user)
  await saveUserToStorage(user, isPremiumUser, isSubscriptionExpired)
}

export const addAccountsListeners = (startListening: AddListenerOverloads<unknown>) => {
  startListening({
    matcher: accountApi.endpoints.signIn.matchFulfilled,
    effect: async (action, listenerApi) => {
      listenerApi.cancelActiveListeners()

      const { user, token } = action.payload

      listenerApi.dispatch(
        accountSlice.actions.updateUser({
          user,
          token,
        })
      )

      await updateStorage(user, token)
    },
  })

  startListening({
    matcher: accountApi.endpoints.signInWithApple.matchFulfilled,
    effect: async (action, listenerApi) => {
      listenerApi.cancelActiveListeners()

      const { user, token } = action.payload

      listenerApi.dispatch(
        accountSlice.actions.updateUser({
          user,
          token,
        })
      )

      await updateStorage(user, token)
    },
  })

  startListening({
    matcher: accountApi.endpoints.createAccount.matchFulfilled,
    effect: async (action, listenerApi) => {
      listenerApi.cancelActiveListeners()

      const { user, token } = action.payload

      listenerApi.dispatch(
        accountSlice.actions.updateUser({
          user,
          token,
        })
      )

      await updateStorage(user, token)
    },
  })

  startListening({
    matcher: accountApi.endpoints.getUser.matchFulfilled,
    effect: async (action, listenerApi) => {
      listenerApi.cancelActiveListeners()

      const user = action.payload

      listenerApi.dispatch(
        accountSlice.actions.updateUserObject({
          user,
        })
      )

      await updateUserInStorage(user)
    },
  })

  startListening({
    matcher: accountApi.endpoints.activateSubscription.matchFulfilled,
    effect: async (action, listenerApi) => {
      listenerApi.cancelActiveListeners()

      const { user, token } = action.payload

      listenerApi.dispatch(
        accountSlice.actions.updateUser({
          user,
          token,
        })
      )

      await updateStorage(user, token)
    },
  })
}
